module.exports = __webpack_public_path__ + "static/media/qr.69b38b2d.svg";